/**
 * Created by fers on 08/08/2017.
 */
import React from 'react';
import PropTypes from 'prop-types';
/* global setTimeout, clearTimeout */

export default class RefreshButton extends React.Component {
    static propTypes = {
        autoRefresh: PropTypes.bool,
        className: PropTypes.string,
        fastRefresh: PropTypes.bool,
        relay: PropTypes.object.isRequired,
    };

    constructor(props) {
        super(props);

        this.state = {
            refreshInProgress: false
        };

        if (this.props.fastRefresh) {
            this.prolongConstant = 1000;
        } else {
            this.prolongConstant = 5000;
        }
    }

    _clearTimeout() {
        if (this.timer) {
            clearTimeout(this.timer);
            this.timer = null;
        }
    }

    rescheduleTimer() {
        this._clearTimeout();

        if (!this.props.autoRefresh) {
            return;
        }

        this.timer = setTimeout(() => {
            this.refresh();

            if (this.props.fastRefresh) {
                this.prolongConstant = this.prolongConstant * 1.2;
                if (this.prolongConstant > 9000) {
                    this.prolongConstant = 9000;
                }
            } else {
                this.prolongConstant = this.prolongConstant * 2.0;
                if (this.prolongConstant > 50000) {
                    this.prolongConstant = 50000;
                }
            }
        }, this.prolongConstant + 1000);
    }

    refresh = () => {
        // For autoRefresh: skip refreshing while user is on a paged view (after/before set),
        // to prevent overriding the just-loaded page.
        const currentVars = (this.props.relay && this.props.relay.variables) ? this.props.relay.variables : {};
        const pagingActive = !!(currentVars && (currentVars.after || currentVars.before));
        const hasPending = !!(this.props.relay && this.props.relay.pendingVariables);

        if (this.props.autoRefresh && (pagingActive || hasPending)) {
            // Do not schedule next immediate refresh while paging is active
            this._clearTimeout();
            return;
        }

        this.rescheduleTimer();
        this.setState({refreshInProgress: true});

        // Preserve current relay variables (e.g., paging: after/before, first/last)
        return this.props.relay.forceFetch(currentVars, (state) => {
            if (state.done || state.error) {
                this.setState({refreshInProgress: false});
            }
        });
    };

    componentDidMount() {
        this.refresh();
    }

    componentWillReceiveProps(nextProps) {
        const nextVars = (nextProps.relay && nextProps.relay.variables) ? nextProps.relay.variables : {};
        const pagingActive = !!(nextVars && (nextVars.after || nextVars.before));
        const hasPending = !!(nextProps.relay && nextProps.relay.pendingVariables);
        if (nextProps.autoRefresh && !pagingActive && !hasPending && !this.timer) {
            this.rescheduleTimer();
        }
    }

    componentWillUnmount() {
        this._clearTimeout();
    }

    render() {
        return (
            <div className={"btn btn-default " + (this.props.className ? this.props.className : "")} onClick={this.refresh}><span className={"fa fa-refresh " + (this.state.refreshInProgress ? " fa-spin " : "")}/></div>
        );
    }

}
